import { createContext} from 'react';

const ColorContext = createContext({
  mode: 'light',
  toggleMode: (mode) => {},
});

export default ColorContext;